import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getQuotationDetails, clearQuotationDetails } from '../../../../redux/Slices/authSlice';

const COLORS = {
  neutral: '#B3B3B3',
};


// quotation details component
const QuotationDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { quotationDetails } = useSelector((s) => s.auth);

  useEffect(() => {
    dispatch(getQuotationDetails(id));
    return () => {
      dispatch(clearQuotationDetails());
    };
  }, [dispatch, id]);

  const quotation = quotationDetails || {};

  const formatDate = (val) => (val ? String(val).split('T')[0] : '—');

  const formatCurrency = (value) =>
    value === undefined || value === null
      ? '—'
      : Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const formatPercent = (value) =>
    value === undefined || value === null
      ? '—'
      : `${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: '20px' }}>تفاصيل عرض السعر</h1>
        <button onClick={() => navigate('/quotations')} style={{ background: '#444', color: 'white', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}>
          رجوع
        </button>
      </div>

      <div style={{ background: '#1b3350', border: '1px solid #333', borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          <InfoBlock label="رقم العرض" value={quotation.quotation_no || quotation.quotation_number || quotation.id} />
          <InfoBlock label="رقم الإصدار" value={quotation.version_no || '—'} />
          <InfoBlock label="المشروع" value={quotation.project?.name_ar || quotation.project?.name_en || quotation.project?.code || '—'} />
          {quotation.client_label ? (
            <InfoBlock
              label={quotation.client_label === 'contractor' ? 'المقاول' : 'العميل'}
              value={quotation.customer_name || quotation.contractor?.name_ar || quotation.contractor?.name_en || quotation.customer?.name_ar || quotation.customer?.name_en || '—'}
            />
          ) : (
            <InfoBlock
              label="العميل"
              value={quotation.customer_name || quotation.contractor?.name_ar || quotation.contractor?.name_en || quotation.customer?.name_ar || quotation.customer?.name_en || '—'}
            />
          )}
          <InfoBlock label="الموضوع" value={quotation.subject || '—'} />
          <InfoBlock label="الانتباه إلى" value={quotation.attention_to || '—'} />
          <InfoBlock label="الموقع" value={quotation.location || '—'} />
          <InfoBlock label="صالح حتى" value={quotation.valid_until ? formatDate(quotation.valid_until) : '—'} />
          <InfoBlock label="عدد البنود" value={quotation.items?.length || 0} />
          <InfoBlock label="الإجمالي الفرعي" value={formatCurrency(quotation.subtotal_amount || quotation.subtotal)} />
          <InfoBlock label="نسبة الخصم" value={quotation.discount_percent ? `${quotation.discount_percent}%` : '—'} />
          <InfoBlock label="نسبة الضريبة" value={quotation.vat_percent ? `${quotation.vat_percent}%` : '—'} />
          <InfoBlock label="نسبة ضريبة الدخل" value={quotation.income_tax_percent ? `${quotation.income_tax_percent}%` : '—'} />
          <InfoBlock label="الإجمالي النهائي" value={formatCurrency(quotation.total_amount)} />
          <InfoBlock label="الحالة" value={quotation.status || '—'} />
          <InfoBlock label="تاريخ الإرسال" value={quotation.sent_at ? formatDate(quotation.sent_at) : '—'} />
          <InfoBlock label="تاريخ الموافقة" value={quotation.approved_at ? formatDate(quotation.approved_at) : '—'} />
          <InfoBlock label="تاريخ الإنشاء" value={formatDate(quotation.created_at)} />
          <InfoBlock label="تاريخ التحديث" value={formatDate(quotation.updated_at)} />
          {quotation.introduction && (
            <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
              <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>المقدمة:</strong>
              <span style={{ display: 'block', color: 'white', whiteSpace: 'pre-wrap' }}>{quotation.introduction}</span>
            </div>
          )}
          {quotation.payment_terms && (
            <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
              <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>شروط الدفع:</strong>
              <span style={{ display: 'block', color: 'white', whiteSpace: 'pre-wrap' }}>{quotation.payment_terms}</span>
            </div>
          )}
          {quotation.terms_and_conditions && (
            <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
              <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>الشروط والأحكام:</strong>
              <span style={{ display: 'block', color: 'white', whiteSpace: 'pre-wrap' }}>{quotation.terms_and_conditions}</span>
            </div>
          )}
          {quotation.notes && (
            <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
              <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>ملاحظات:</strong>
              <span style={{ display: 'block', color: 'white', whiteSpace: 'pre-wrap' }}>{quotation.notes}</span>
            </div>
          )}
        </div>
      </div>

      {quotation.items && quotation.items.length > 0 && (
        <div style={{ background: '#1b3350', border: '1px solid #333', borderRadius: 12, padding: 24 }}>
          <h2 style={{ marginTop: 0, marginBottom: 16, fontSize: '18px' }}>البنود</h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 800 }}>
              <thead>
                <tr style={{ backgroundColor: '#AC2000' }}>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>#</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>النوع</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>الوصف (عربي)</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>الوصف (إنجليزي)</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>الوحدة</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>الكمية</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>سعر الوحدة</th>
                  <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>الإجمالي</th>
                  {quotation.items.some((item) => item.is_client_approved !== undefined) && (
                    <th style={{ padding: 12, textAlign: 'center', color: 'white', fontSize: 14 }}>معتمد</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {quotation.items.map((item, index) => {
                  const total = item.item_type === 'item' ? (Number(item.qty || 0) * Number(item.unit_price || 0)) : 0;
                  const itemTypeLabel = item.item_type === 'section' ? 'قسم' : item.item_type === 'note' ? 'ملاحظة' : 'بند';
                  return (
                    <tr key={index} style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{item.line_no || index + 1}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{itemTypeLabel}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{item.description_ar || '—'}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{item.description_en || '—'}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>
                        {item.measurable
                          ? (item.measurable.symbol ? `${item.measurable.name_ar} (${item.measurable.symbol})` : item.measurable.name_ar || item.measurable.name_en || '—')
                          : (item.unit
                            ? (item.unit.display_name || (item.unit.symbol ? `${item.unit.name_ar} (${item.unit.symbol})` : item.unit.name_ar || item.unit.name_en || '—'))
                            : '—')
                        }
                      </td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{item.qty || (item.item_type === 'item' ? 0 : '—')}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>{item.item_type === 'item' ? formatCurrency(item.unit_price) : '—'}</td>
                      <td style={{ padding: 12, textAlign: 'center', color: '#F6630D', fontWeight: 600 }}>{item.item_type === 'item' ? formatCurrency(total) : '—'}</td>
                      {item.is_client_approved !== undefined && (
                        <td style={{ padding: 12, textAlign: 'center', color: 'white' }}>
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '4px 12px',
                              borderRadius: '12px',
                              fontSize: 12,
                              fontWeight: 600,
                              color: item.is_client_approved ? '#27ae60' : COLORS.neutral,
                              backgroundColor: item.is_client_approved ? 'rgba(39,174,96,0.2)' : 'rgba(179,179,179,0.2)',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {item.is_client_approved ? 'معتمد' : 'غير معتمد'}
                          </span>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const InfoBlock = ({ label, value }) => (
  <div style={{ padding: '12px 0' }}>
    <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>{label}</strong>
    <span style={{ display: 'block', color: 'white' }}>{value || '—'}</span>
  </div>
);

export default QuotationDetails;

